import styled from "styled-components";

type LinkButtonVariant = "primary" | "secondary";

const ButtonComponent = styled.button<{ block?: boolean; variant: LinkButtonVariant }>`
    font-size: ${({ block }) => (block ? "inherit" : "1rem")};
    background: none;
    border: none;
    display: ${({ block }) => (block ? "block" : "inline")};
    font-family: Inter, sans-serif;
    color: ${({ theme, variant }) => theme.color[variant].background};
    font-weight: ${({ block }) => (block ? "normal" : "bold")};
    ${({ block }) => (block ? "width: 100%;" : "")};
    text-align: left;

    &:hover {
        cursor: pointer;
        ${({ block }) => (block ? "" : "text-decoration: underline;")};
    }
`;

type LinkButtonProps = {
    variant?: LinkButtonVariant;
    children: any;
    [key: string]: any;
};

const LinkButton: React.FC<LinkButtonProps> = ({ children, variant = "primary", ...props }) => {
    return (
        <ButtonComponent type="button" variant={variant ?? "primary"} {...props}>
            {children}
        </ButtonComponent>
    );
};

export default LinkButton;
